<template>
  <v-app class="futuristic-app">
    <v-app-bar app flat height="74" class="layanan-header">
      <div class="header-inner">
        <v-btn icon class="back-btn" @click="$router.back()" aria-label="Kembali">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <div class="header-brand">
          <div class="brand-mark">
            <img src="/images/icon2.png" width="40" alt="Bondowoso Berkah" />
          </div>

          <div class="brand-copy d-block d-sm-none d-md-block">
            <div class="brand-name">BONDOWOSO <span>BERKAH</span></div>
            <div class="brand-tagline">Berkualitas, Akseleratif dan Holistik</div>
          </div>
        </div>

        <v-spacer />

        <v-responsive max-width="460" class="header-search-wrap flex-grow-1 mr-3">
          <v-autocomplete
            v-model="selectedSubId"
            :items="filteredSub"
            item-text="nama_sub"
            item-value="id"
            placeholder="Cari lokasi tenant..."
            prepend-inner-icon="mdi-magnify"
            clearable
            flat
            solo
            rounded
            hide-details
            background-color="#f1f6f5"
            color="#018c74"
            class="cyber-search-dropdown"
            @change="handleFilterChange"
          >
            <template v-slot:item="{ item }">
              <v-list-item-avatar class="icon-hexagon-super-small pa-1" tile size="30">
                <v-img :src="item.full_url" contain></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="black--text font-weight-bold">
                  {{ item.nama_sub }}
                </v-list-item-title>
                <v-list-item-subtitle class="grey--text text-caption">
                  Kategori: {{ item.nama_kategori }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-responsive>

        <v-btn
          depressed
          rounded
          outlined
          color="#018c74"
          class="font-weight-bold mr-2 hidden-xs-only"
          height="40"
          @click="resetFilter"
        >
          <v-icon left small>mdi-eye</v-icon>
          Tampilkan Semua
        </v-btn>

        <div class="header-info d-none d-lg-flex">
          <div class="header-info-icon">
            <v-icon size="18" color="#018c74">mdi-storefront-outline</v-icon>
          </div>
          <div>
            <div class="header-info-title">Peta Tenant</div>
            <div class="header-info-subtitle">Sebaran lokasi tenant</div>
          </div>
        </div>
      </div>
    </v-app-bar>

    <v-main class="main-area">
      <v-container fluid class="content-layer">
        <div class="page-intro">
          <div class="intro-copy">
            <div class="intro-eyebrow">
              <span class="intro-eyebrow-dot"></span>
              EKSPLORASI LOKASI
            </div>

            <h1 class="intro-title">Temukan Tenant <span>Favorit Anda.</span></h1>

            <p class="intro-description">
              Jelajahi persebaran tenant di Bondowoso dan temukan lokasi yang ingin Anda
              kunjungi melalui peta interaktif.
            </p>
          </div>

          <div class="intro-badge">
            <v-icon color="#018c74" size="20">mdi-map-marker-radius-outline</v-icon>
            <div>
              <div class="intro-badge-title">Peta Interaktif</div>
              <div class="intro-badge-subtitle">Bondowoso, Jawa Timur</div>
            </div>
          </div>
        </div>

        <div class="stats-grid">
          <div class="stat-card">
            <div class="stat-icon stat-icon-green">
              <v-icon color="#018c74">mdi-storefront-outline</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Total Tenant</div>
              <div class="stat-value">{{ allTenantsInCategory.length }}</div>
              <div class="stat-note">Sesuai filter kategori</div>
            </div>
          </div>

          <div class="stat-card">
            <div class="stat-icon stat-icon-gold">
              <v-icon color="#b58b20">mdi-shape-outline</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Kategori</div>
              <div class="stat-value">{{ filteredSub.length }}</div>
              <div class="stat-note">Kategori yang tersedia</div>
            </div>
          </div>

          <div class="stat-card stat-card-highlight">
            <div class="stat-icon stat-icon-white">
              <v-icon color="#ffffff">mdi-crosshairs-gps</v-icon>
            </div>
            <div class="stat-content">
              <div class="stat-label">Hasil Pencarian</div>
              <div class="stat-value">{{ displayedTenants.length }}</div>
              <div class="stat-note">Tenant yang ditampilkan</div>
            </div>
          </div>
        </div>

        <div class="workspace-grid">
          <v-card flat class="map-panel">
            <div class="panel-heading">
              <div class="panel-heading-left">
                <div class="panel-heading-icon">
                  <v-icon color="#018c74">mdi-map-outline</v-icon>
                </div>
                <div>
                  <div class="panel-title">Peta Persebaran Tenant</div>
                  <div class="panel-subtitle">
                    Klik penanda pada peta untuk melihat detail tenant
                  </div>
                </div>
              </div>
            </div>

            <div class="map-stage">
              <div id="map" class="main-map-display"></div>

              <div class="map-floating-card">
                <div class="map-floating-icon">
                  <v-icon color="#018c74" size="20">mdi-map-marker-multiple</v-icon>
                </div>
                <div>
                  <div class="map-floating-label">TENANT DITEMUKAN</div>
                  <div class="map-floating-value">
                    {{ displayedTenants.length }} lokasi
                  </div>
                </div>
              </div>

              <div class="map-legend">
                <span class="legend-marker"></span>
                <span>Lokasi tenant</span>
              </div>

              <div v-if="mapLoading" class="map-loading-overlay">
                <v-progress-circular
                  indeterminate
                  color="#018c74"
                  size="32"
                ></v-progress-circular>
                <span>Memuat peta...</span>
              </div>
            </div>

            <div class="panel-footer">
              <div class="panel-footer-left">
                <v-icon size="17" color="#018c74" class="mr-2">
                  mdi-information-outline
                </v-icon>
                <span>Geser peta untuk menjelajahi wilayah.</span>
              </div>

              <v-btn
                small
                text
                color="#018c74"
                class="map-reset-btn"
                @click="fitVisibleMarkers"
              >
                <v-icon left small>mdi-fit-to-screen-outline</v-icon>
                Sesuaikan Peta
              </v-btn>
            </div>
          </v-card>

          <v-card flat class="tenant-panel">
            <div class="tenant-panel-header">
              <div class="tenant-heading-top">
                <div>
                  <div class="tenant-panel-kicker">DIREKTORI LOKASI</div>
                  <div class="tenant-panel-title">Daftar Tenant</div>
                  <div class="tenant-panel-description">
                    Cari dan pilih tenant untuk melihat posisinya.
                  </div>
                </div>

                <div class="tenant-count-badge">
                  {{ displayedTenants.length }}
                </div>
              </div>

              <div class="tenant-search">
                <v-icon color="#018c74" size="21" class="mr-2"> mdi-magnify </v-icon>

                <input
                  v-model="tenantSearch"
                  type="text"
                  placeholder="Cari nama tenant..."
                  aria-label="Cari nama tenant"
                  autocomplete="off"
                />

                <button
                  v-if="tenantSearch"
                  type="button"
                  class="tenant-search-clear"
                  aria-label="Hapus pencarian tenant"
                  @click="clearSearchOnly"
                >
                  <v-icon size="18">mdi-close-circle</v-icon>
                </button>
              </div>

              <div class="filter-info-row">
                <div class="filter-info">
                  <v-icon size="15" color="#018c74" class="mr-1">
                    mdi-filter-variant
                  </v-icon>
                  <span>
                    {{ selectedSubName || "Semua kategori" }}
                  </span>
                </div>

                <button
                  v-if="selectedSubId || tenantSearch"
                  class="reset-search-link"
                  type="button"
                  @click="clearTenantSearch"
                >
                  Reset filter
                </button>
              </div>
            </div>

            <v-divider class="panel-divider"></v-divider>

            <div
              ref="listScroll"
              class="tenant-list-scroll"
              @scroll.passive="onListScroll"
            >
              <div
                v-for="(tenant, index) in visibleTenants"
                :key="tenant.id"
                class="tenant-item"
                :class="{
                  'tenant-item-active': activeTenantId === tenant.id,
                }"
                @click="focusToMarker(tenant)"
              >
                <div class="tenant-item-index">
                  <span>{{ String(index + 1).padStart(2, "0") }}</span>
                </div>

                <div class="tenant-item-icon">
                  <v-icon size="21" color="#018c74"> mdi-storefront-outline </v-icon>
                </div>

                <div class="tenant-item-content">
                  <div class="tenant-name">
                    {{ tenant.nama_profil || "Tenant tanpa nama" }}
                  </div>

                  <div class="tenant-category">
                    <v-icon size="12" class="mr-1"> mdi-tag-outline </v-icon>
                    {{ tenant.nama_sub || "Kategori umum" }}
                  </div>

                  <div class="tenant-location-status">
                    <span
                      class="tenant-status-dot"
                      :class="
                        tenant._hasCoord ? 'status-available' : 'status-unavailable'
                      "
                    ></span>
                    {{
                      tenant._hasCoord ? "Lokasi tersedia" : "Koordinat belum tersedia"
                    }}
                  </div>
                </div>

                <v-btn
                  icon
                  x-small
                  class="tenant-open-btn"
                  :aria-label="'Lihat ' + tenant.nama_profil"
                  @click.stop="openTenantDetail(tenant)"
                >
                  <v-icon size="19">mdi-chevron-right</v-icon>
                </v-btn>
              </div>

              <div v-if="hasMoreToShow" class="tenant-more">
                <button type="button" @click="showMore">
                  Tampilkan lebih banyak ({{ visibleTenants.length }} /
                  {{ displayedTenants.length }})
                </button>
              </div>

              <div v-if="displayedTenants.length === 0 && !loading" class="tenant-empty">
                <div class="tenant-empty-icon">
                  <v-icon size="35" color="#91aaa5">
                    {{ tenantSearch ? "mdi-magnify-close" : "mdi-store-search-outline" }}
                  </v-icon>
                </div>

                <div class="tenant-empty-title">
                  {{
                    tenantSearch ? "Tenant tidak ditemukan" : "Belum ada lokasi tenant"
                  }}
                </div>

                <p class="tenant-empty-description">
                  {{
                    tenantSearch
                      ? "Coba gunakan kata kunci lain atau periksa ejaan nama tenant."
                      : "Belum ada data tenant untuk filter yang dipilih."
                  }}
                </p>

                <v-btn
                  v-if="tenantSearch || selectedSubId"
                  outlined
                  rounded
                  small
                  color="#018c74"
                  @click="clearTenantSearch"
                >
                  <v-icon left small>mdi-refresh</v-icon>
                  Tampilkan Semua
                </v-btn>
              </div>

              <div v-if="loading" class="tenant-loading">
                <v-progress-circular
                  indeterminate
                  color="#018c74"
                  size="28"
                ></v-progress-circular>
                <span>Memuat data tenant...</span>
              </div>
            </div>

            <div class="panel-footer">
              <div class="panel-footer-left">
                <span class="footer-indicator"></span>
                <span>
                  Menampilkan {{ displayedTenants.length }} dari
                  {{ allTenantsInCategory.length }} tenant
                </span>
              </div>
            </div>
          </v-card>
        </div>

        <div class="page-footer"></div>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { getSubCategories, getTenants } from "@/api/androidInitApi";

import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.markercluster";
import "leaflet.markercluster/dist/MarkerCluster.css";
import "leaflet.markercluster/dist/MarkerCluster.Default.css";

const BONDOWOSO_CENTER = [-7.9135, 113.8217];
const SEARCH_DEBOUNCE_MS = 250;
const LIST_PAGE_SIZE = 40;

const DISTRICT_COLORS = [
  "#c9e8df",
  "#d8edda",
  "#f5e7c0",
  "#d4e6f1",
  "#e8dcf4",
  "#f5d9dc",
  "#d7eee9",
  "#e9e3c9",
];

const TENANT_ICON = L.divIcon({
  className: "custom-cyber-marker-wrapper",
  html: `
    <div class="marker-pulse-fx"></div>
    <div class="marker-core-fx"></div>
  `,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
});

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function parseCoordinates(value) {
  if (!value) return null;

  const parts = String(value)
    .split(",")
    .map((item) => Number(item.trim()));

  if (parts.length !== 2 || !parts.every(Number.isFinite)) return null;

  const [lat, lng] = parts;

  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;
  if (lat === 0 && lng === 0) return null;

  return { lat, lng };
}

function normalizeTenant(tenant) {
  const coords = parseCoordinates(tenant.lokasi_map);
  const name = String(tenant.nama_profil || "");
  const category = String(tenant.nama_sub || "");

  return Object.freeze({
    ...tenant,
    _hasCoord: !!coords,
    _lat: coords ? coords.lat : null,
    _lng: coords ? coords.lng : null,
    _subKey: String(tenant.sub_category_id),
    _search: `${name} ${category}`.toLocaleLowerCase("id-ID"),
  });
}

export default {
  name: "PetaTenant",

  data: () => ({
    allSubs: [],
    allTenants: [],

    selectedSubId: null,
    tenantSearch: "",
    searchKeyword: "",
    activeTenantId: null,

    visibleLimit: LIST_PAGE_SIZE,

    loading: true,
    mapLoading: true,
  }),

  computed: {
    filteredSub() {
      const categoryId = this.$route.params.id;

      if (!categoryId) return this.allSubs;

      return this.allSubs.filter((sub) => String(sub.category_id) === String(categoryId));
    },

    selectedSubName() {
      if (!this.selectedSubId) return "";

      const selected = this.filteredSub.find(
        (sub) => String(sub.id) === String(this.selectedSubId)
      );

      return selected ? selected.nama_sub : "";
    },

    allTenantsInCategory() {
      if (!this.$route.params.id) return this.allTenants;

      const subIds = new Set(this.filteredSub.map((sub) => String(sub.id)));

      return this.allTenants.filter((tenant) => subIds.has(tenant._subKey));
    },

    displayedTenants() {
      let tenants = this.allTenantsInCategory;

      if (
        this.selectedSubId !== null &&
        this.selectedSubId !== undefined &&
        this.selectedSubId !== ""
      ) {
        const subKey = String(this.selectedSubId);
        tenants = tenants.filter((tenant) => tenant._subKey === subKey);
      }

      const keyword = this.searchKeyword;

      if (keyword) {
        tenants = tenants.filter((tenant) => tenant._search.includes(keyword));
      }

      return tenants;
    },

    mappedTenantsCount() {
      let count = 0;
      const list = this.allTenantsInCategory;

      for (let i = 0; i < list.length; i++) {
        if (list[i]._hasCoord) count++;
      }

      return count;
    },

    visibleTenants() {
      return this.displayedTenants.slice(0, this.visibleLimit);
    },

    hasMoreToShow() {
      return this.visibleLimit < this.displayedTenants.length;
    },
  },

  watch: {
    tenantSearch(value) {
      clearTimeout(this.searchTimer);

      const keyword = String(value || "")
        .trim()
        .toLocaleLowerCase("id-ID");

      if (!keyword) {
        this.searchKeyword = "";
        return;
      }

      this.searchTimer = setTimeout(() => {
        this.searchKeyword = keyword;
      }, SEARCH_DEBOUNCE_MS);
    },

    displayedTenants() {
      this.visibleLimit = LIST_PAGE_SIZE;

      this.$nextTick(() => {
        const scroller = this.$refs.listScroll;
        if (scroller) scroller.scrollTop = 0;

        this.renderMarkers();
      });
    },

    "$route.params.id"() {
      this.selectedSubId = null;
      this.tenantSearch = "";
      this.searchKeyword = "";
      this.activeTenantId = null;
    },
  },

  created() {
    this.map = null;
    this.markerClusterGroup = null;
    this.boundaryLayer = null;
    this.districtLayer = null;
    this.markerById = {};
    this.activeMarker = null;
    this.renderedList = null;
    this.searchTimer = null;
  },

  async mounted() {
    await this.loadData();
  },

  beforeDestroy() {
    clearTimeout(this.searchTimer);

    if (this.markerClusterGroup) {
      this.markerClusterGroup.clearLayers();
      this.markerClusterGroup = null;
    }

    if (this.map) {
      this.map.off();
      this.map.remove();
      this.map = null;
    }

    this.markerById = {};
    this.activeMarker = null;
  },

  methods: {
    async loadData() {
      this.loading = true;

      try {
        const [subCategories, tenants] = await Promise.all([
          getSubCategories(),
          getTenants(),
        ]);

        this.allSubs = Object.freeze(Array.isArray(subCategories) ? subCategories : []);
        this.allTenants = Object.freeze(
          (Array.isArray(tenants) ? tenants : []).map(normalizeTenant)
        );
      } catch (error) {
        console.error("Gagal memuat data tenant:", error);

        this.allSubs = Object.freeze([]);
        this.allTenants = Object.freeze([]);
      } finally {
        this.loading = false;
      }

      await this.$nextTick();

      this.initMapStructure();

      this.renderMarkers(true);
      this.mapLoading = false;

      if (this.map) this.map.invalidateSize();

      this.loadGeoLayers();
    },

    initMapStructure() {
      if (this.map) return;

      const mapElement = document.getElementById("map");
      if (!mapElement) return;

      this.map = L.map(mapElement, {
        zoomControl: false,
        attributionControl: false,
        preferCanvas: true,
      }).setView(BONDOWOSO_CENTER, 12);

      L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
        attribution: "&copy; OpenStreetMap contributors",
        maxZoom: 19,
        updateWhenIdle: true,
        keepBuffer: 2,
      }).addTo(this.map);

      L.control.zoom({ position: "bottomright" }).addTo(this.map);

      L.control
        .attribution({
          position: "bottomleft",
          prefix: false,
        })
        .addTo(this.map);

      this.markerClusterGroup = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        spiderfyOnMaxZoom: true,
        disableClusteringAtZoom: 16,
        maxClusterRadius: 60,
        chunkedLoading: true,
        animate: false,
        animateAddingMarkers: false,
        removeOutsideVisibleBounds: true,

        iconCreateFunction: (cluster) =>
          L.divIcon({
            html: `
              <div class="cluster-outer">
                <div class="cluster-inner">
                  <span>${cluster.getChildCount()}</span>
                </div>
              </div>
            `,
            className: "cyber-cluster-icon",
            iconSize: L.point(42, 42),
          }),
      });

      this.map.addLayer(this.markerClusterGroup);
    },

    async loadGeoLayers() {
      await Promise.all([this.loadBoundary(), this.loadDistrict()]);
    },

    async loadBoundary() {
      if (!this.map) return;

      try {
        const response = await fetch("/images/35.11_Bondowoso.geojson");

        if (!response.ok) {
          throw new Error("GeoJSON batas kabupaten tidak ditemukan");
        }

        const geojson = await response.json();

        if (!this.map) return;

        if (this.boundaryLayer) {
          this.map.removeLayer(this.boundaryLayer);
        }

        this.boundaryLayer = L.geoJSON(geojson, {
          interactive: false,
          style: {
            color: "#018c74",
            weight: 3,
            opacity: 0.9,
            fillColor: "#018c74",
            fillOpacity: 0.025,
          },
        }).addTo(this.map);
      } catch (error) {
        console.error("Gagal memuat batas Bondowoso:", error);
      }
    },

    async loadDistrict() {
      if (!this.map) return;

      try {
        const response = await fetch("/images/35.11_kecamatan.geojson");

        if (!response.ok) {
          throw new Error("GeoJSON kecamatan tidak ditemukan");
        }

        const geojson = await response.json();

        if (!this.map) return;

        if (this.districtLayer) {
          this.map.removeLayer(this.districtLayer);
        }

        this.districtLayer = L.geoJSON(geojson, {
          style: (feature) => {
            const id = Number(feature.properties?.OBJECTID || 0);

            return {
              color: "#ffffff",
              weight: 1.5,
              opacity: 1,
              fillColor: DISTRICT_COLORS[Math.abs(id) % DISTRICT_COLORS.length],
              fillOpacity: 0.18,
            };
          },

          onEachFeature: (feature, layer) => {
            const properties = feature.properties || {};

            const name =
              properties.nm_kecamatan ||
              properties.NAMOBJ ||
              properties.WADMKC ||
              "Kecamatan";

            layer.bindTooltip(name, {
              permanent: true,
              direction: "center",
              className: "label-kecamatan",
            });

            layer.bindPopup(
              `<div style="min-width:160px;padding:4px">
                <strong style="font-size:14px">${escapeHtml(name)}</strong>
                <div style="margin-top:5px;color:#64748b">
                  Wilayah Kecamatan ${escapeHtml(name)}
                </div>
              </div>`
            );

            layer.on({
              mouseover: (event) => {
                event.target.setStyle({
                  weight: 2.5,
                  fillOpacity: 0.35,
                });
              },

              mouseout: (event) => {
                if (this.districtLayer) {
                  this.districtLayer.resetStyle(event.target);
                }
              },
            });
          },
        }).addTo(this.map);
      } catch (error) {
        console.error("Gagal memuat batas kecamatan:", error);
      }
    },

    getMarker(tenant) {
      const key = String(tenant.id);
      let marker = this.markerById[key];

      if (marker) return marker;

      marker = L.marker([tenant._lat, tenant._lng], {
        icon: TENANT_ICON,
        title: tenant.nama_profil || "Tenant",
        alt: tenant.nama_profil || "Tenant",
      });

      marker.on("mouseover", () => {
        if (!marker.getTooltip()) {
          this.bindTenantTooltip(marker, tenant, false);
          marker.openTooltip();
        }
      });

      marker.on("click", (event) => {
        L.DomEvent.stopPropagation(event);
        this.openTenantDetail(tenant);
      });

      this.markerById[key] = marker;

      return marker;
    },

    bindTenantTooltip(marker, tenant, permanent) {
      const tenantName = escapeHtml(tenant.nama_profil || "Tenant tanpa nama");

      marker.bindTooltip(
        `<div class="cyber-tooltip-content">
          <div class="tooltip-name">${tenantName}</div>
        </div>`,
        {
          permanent,
          direction: "top",
          className: "cyber-leaflet-tooltip",
          offset: [0, -12],
        }
      );
    },

    renderMarkers(force = false) {
      if (!this.map || !this.markerClusterGroup) return;

      const list = this.displayedTenants;

      if (!force && this.renderedList === list) return;

      this.renderedList = list;

      if (this.activeMarker) {
        this.activeMarker.unbindTooltip();
        this.activeMarker = null;
      }

      const markers = [];

      for (let i = 0; i < list.length; i++) {
        if (list[i]._hasCoord) markers.push(this.getMarker(list[i]));
      }

      this.markerClusterGroup.clearLayers();
      this.markerClusterGroup.addLayers(markers);
    },

    applyAndFit() {
      this.$nextTick(() => {
        this.renderMarkers();
        this.fitVisibleMarkers();
      });
    },

    handleFilterChange() {
      this.activeTenantId = null;
      this.applyAndFit();
    },

    resetFilter() {
      clearTimeout(this.searchTimer);
      this.selectedSubId = null;
      this.tenantSearch = "";
      this.searchKeyword = "";
      this.activeTenantId = null;

      this.applyAndFit();
    },

    clearTenantSearch() {
      this.resetFilter();
    },

    clearSearchOnly() {
      clearTimeout(this.searchTimer);
      this.tenantSearch = "";
      this.searchKeyword = "";
    },

    onListScroll(event) {
      if (!this.hasMoreToShow) return;

      const el = event.target;

      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 240) {
        this.showMore();
      }
    },

    showMore() {
      this.visibleLimit = Math.min(
        this.visibleLimit + LIST_PAGE_SIZE,
        this.displayedTenants.length
      );
    },

    focusToMarker(tenant) {
      this.activeTenantId = tenant.id;

      const marker = this.markerById[String(tenant.id)];

      if (
        marker &&
        this.map &&
        this.markerClusterGroup &&
        this.markerClusterGroup.hasLayer(marker)
      ) {
        this.map.invalidateSize();

        this.markerClusterGroup.zoomToShowLayer(marker, () => {
          this.map.setView(marker.getLatLng(), 17, { animate: true });

          if (this.activeMarker && this.activeMarker !== marker) {
            this.activeMarker.unbindTooltip();
          }

          marker.unbindTooltip();
          this.bindTenantTooltip(marker, tenant, true);
          marker.openTooltip();

          this.activeMarker = marker;
        });

        return;
      }

      this.$emit("tenant-selected", tenant);
    },

    openTenantDetail(tenant) {
      this.$router.push(`/tenant-detail/${tenant.id}`).catch((error) => {
        if (error && error.name !== "NavigationDuplicated") {
          console.error("Gagal membuka detail tenant:", error);
        }
      });
    },

    fitVisibleMarkers() {
      if (!this.map) return;

      this.map.invalidateSize();

      const points = [];
      const list = this.displayedTenants;

      for (let i = 0; i < list.length; i++) {
        if (list[i]._hasCoord) points.push([list[i]._lat, list[i]._lng]);
      }

      if (points.length > 0) {
        this.map.fitBounds(L.latLngBounds(points), {
          padding: [45, 45],
          maxZoom: 15,
          animate: true,
        });
        return;
      }

      if (this.boundaryLayer) {
        this.map.fitBounds(this.boundaryLayer.getBounds(), {
          padding: [20, 20],
        });
      } else {
        this.map.setView(BONDOWOSO_CENTER, 12);
      }
    },
  },
};
</script>

<style scoped>
.futuristic-app {
  --gap: 16px;
  --radius-card: 18px;
  --panel-height: 680px;
  --stat-height: 104px;

  background: #f5f8f7 !important;
  color: #243b37;
}

.main-area {
  background: radial-gradient(circle at 0% 0%, rgba(1, 140, 116, 0.045), transparent 28%),
    #f5f8f7;
}

.content-layer {
  width: 100%;
  max-width: 1440px;
  padding: 24px 24px 12px;
  margin: 0 auto;
}

.layanan-header {
  background: rgba(255, 255, 255, 0.94) !important;
  backdrop-filter: blur(18px);
  border-bottom: 1px solid rgba(1, 140, 116, 0.08) !important;
  z-index: 100 !important;
}

.header-inner {
  width: 100%;
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}

.back-btn {
  width: 42px !important;
  height: 42px !important;
  background: #f1f6f5;
  margin-right: 10px;
}

.back-btn:hover {
  background: #e8f5f2;
}

.header-brand {
  display: flex;
  align-items: center;
  gap: 10px;
}

.brand-mark {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: linear-gradient(135deg, #e4f6f1, #f5fbf9);
  border: 1px solid rgba(1, 140, 116, 0.1);
}

.brand-name {
  font-size: 15px;
  font-weight: 900;
  letter-spacing: 0.5px;
  color: #17423b;
  line-height: 1.1;
}

.brand-name span {
  color: #018c74;
}

.brand-tagline {
  font-size: 9px;
  color: #8a969b;
  margin-top: 3px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 9px;
  min-width: 0;
}

.header-info > div:last-child {
  min-width: 0;
}

.header-info-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #f1faf8;
  display: flex;
  align-items: center;
  justify-content: center;
}

.header-info-title {
  font-size: 12px;
  font-weight: 800;
  color: #34514c;
}

.header-info-subtitle {
  max-width: 260px;
  font-size: 10px;
  color: #929da1;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-search-wrap {
  min-width: 0;
}

.icon-hexagon-super-small {
  background: rgba(1, 140, 116, 0.1);
  clip-path: polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%);
}

.cyber-search-dropdown ::v-deep .v-input__slot {
  min-height: 42px !important;
  background: #f1f6f5 !important;
  border: 1px solid rgba(1, 140, 116, 0.12) !important;
  box-shadow: none !important;
  transition: all 0.25s ease;
}

.cyber-search-dropdown ::v-deep .v-input__slot:focus-within {
  background: #ffffff !important;
  border-color: #018c74 !important;
}

.cyber-search-dropdown ::v-deep .v-icon {
  color: #018c74;
}

.page-intro {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
  margin-bottom: var(--gap);
}

.intro-copy {
  min-width: 0;
}

.intro-eyebrow {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.7px;
  color: #018c74;
  margin-bottom: 8px;
}

.intro-eyebrow-dot {
  width: 7px;
  height: 7px;
  background: #cfa22d;
  border-radius: 50%;
  box-shadow: 0 0 0 4px rgba(207, 162, 45, 0.13);
}

.intro-title {
  font-size: clamp(23px, 2.4vw, 32px);
  font-weight: 850;
  letter-spacing: -1.1px;
  line-height: 1.25;
  color: #193b34;
  margin: 0;
}

.intro-title span {
  color: #018c74;
}

.intro-description {
  max-width: 650px;
  font-size: 13px;
  line-height: 1.7;
  color: #7b8c87;
  margin: 8px 0 0;
}

.intro-badge {
  display: flex;
  align-items: center;
  gap: 11px;
  flex-shrink: 0;
  padding: 13px 17px;
  background: #ffffff;
  border: 1px solid #e5efeb;
  border-radius: 14px;
  box-shadow: 0 4px 15px rgba(27, 69, 58, 0.025);
}

.intro-badge-title {
  font-size: 12px;
  font-weight: 800;
  color: #29483f;
}

.intro-badge-subtitle {
  margin-top: 3px;
  font-size: 10px;
  color: #91a09b;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--gap);
  margin-bottom: var(--gap);
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 14px;
  height: var(--stat-height);
  padding: 0 20px;
  background: #ffffff;
  border: 1px solid #e8efec;
  border-radius: var(--radius-card);
  box-shadow: 0 5px 22px rgba(30, 74, 62, 0.035);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 9px 24px rgba(30, 74, 62, 0.07);
}

.stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
  border-radius: 14px;
}

.stat-icon-green {
  background: #e8f6f1;
}

.stat-icon-gold {
  background: #fbf4df;
}

.stat-icon-white {
  background: rgba(255, 255, 255, 0.17);
}

.stat-content {
  min-width: 0;
}

.stat-label {
  font-size: 11px;
  font-weight: 600;
  color: #82938d;
  margin-bottom: 2px;
}

.stat-value {
  font-size: 26px;
  font-weight: 850;
  letter-spacing: -0.7px;
  line-height: 1.15;
  color: #24483e;
}

.stat-note {
  font-size: 10px;
  color: #9aa8a3;
  margin-top: 4px;
}

.stat-card-highlight {
  background: linear-gradient(125deg, #018c74, #08705f);
  border-color: transparent;
}

.stat-card-highlight .stat-label,
.stat-card-highlight .stat-note {
  color: rgba(255, 255, 255, 0.76);
}

.stat-card-highlight .stat-value {
  color: #ffffff;
}

.workspace-grid {
  display: grid;
  grid-template-columns: minmax(0, 2fr) minmax(0, 1fr);
  gap: var(--gap);
  height: var(--panel-height);
}

.map-panel,
.tenant-panel {
  display: flex !important;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
  background: #ffffff !important;
  border: 1px solid #e6eeeb !important;
  border-radius: var(--radius-card) !important;
  box-shadow: 0 5px 22px rgba(30, 74, 62, 0.035) !important;
}

.panel-heading,
.tenant-panel-header {
  flex-shrink: 0;
}

.panel-footer {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  height: 48px;
  padding: 0 16px;
  border-top: 1px solid #edf2f0;
}

.panel-footer-left {
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
  font-size: 10px;
  color: #91a09b;
}

.panel-heading {
  height: 80px;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #edf2f0;
}

.panel-heading-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.panel-heading-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  background: #e9f6f2;
  border-radius: 13px;
}

.panel-title {
  font-size: 14px;
  font-weight: 850;
  color: #23443a;
}

.panel-subtitle {
  font-size: 10px;
  color: #91a09b;
  line-height: 1.5;
  margin-top: 3px;
}

.map-live-status {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  flex-shrink: 0;
  padding: 7px 10px;
  border-radius: 8px;
  background: #eff8f4;
  color: #018c74;
  font-size: 9px;
  font-weight: 850;
  letter-spacing: 0.7px;
}

.live-dot {
  width: 6px;
  height: 6px;
  background: #14a783;
  border-radius: 50%;
  box-shadow: 0 0 0 3px rgba(20, 167, 131, 0.12);
}

.map-stage {
  position: relative;
  flex: 1;
  min-height: 0;
  background: #edf4f1;
}

.main-map-display {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.map-floating-card {
  position: absolute;
  top: 16px;
  left: 16px;
  z-index: 400;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.96);
  border: 1px solid rgba(226, 237, 232, 0.9);
  border-radius: 12px;
  box-shadow: 0 4px 18px rgba(20, 60, 48, 0.09);
  pointer-events: none;
}

.map-floating-icon {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9f6f2;
  border-radius: 10px;
}

.map-floating-label {
  font-size: 8px;
  letter-spacing: 0.8px;
  color: #8b9b95;
  font-weight: 800;
}

.map-floating-value {
  margin-top: 3px;
  font-size: 13px;
  color: #29483e;
  font-weight: 850;
}

.map-legend {
  position: absolute;
  left: 16px;
  bottom: 16px;
  z-index: 400;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 9px 12px;
  border: 1px solid #e6eeeb;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.96);
  color: #667c74;
  font-size: 10px;
  font-weight: 650;
  pointer-events: none;
}

.legend-marker {
  width: 9px;
  height: 9px;
  background: #cfa22d;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 0 2px #018c74;
}

.map-loading-overlay {
  position: absolute;
  inset: 0;
  z-index: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  background: rgba(245, 249, 247, 0.88);
  color: #52736a;
  font-size: 12px;
}

.map-reset-btn {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 750;
}

.tenant-panel-header {
  padding: 18px 18px 14px;
}

.tenant-heading-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
}

.tenant-panel-kicker {
  font-size: 9px;
  letter-spacing: 1.4px;
  font-weight: 850;
  color: #018c74;
  margin-bottom: 5px;
}

.tenant-panel-title {
  font-size: 20px;
  font-weight: 850;
  letter-spacing: -0.5px;
  color: #24483e;
  line-height: 1.25;
}

.tenant-panel-description {
  margin-top: 4px;
  color: #8b9a95;
  font-size: 10px;
  line-height: 1.6;
}

.tenant-count-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 38px;
  height: 38px;
  padding: 0 8px;
  background: #e8f6f1;
  border: 1px solid #d9eee6;
  color: #018c74;
  font-size: 14px;
  font-weight: 850;
  border-radius: 12px;
}

.tenant-search {
  display: flex;
  align-items: center;
  height: 44px;
  padding: 0 12px;
  margin-top: 14px;
  background: #f5f8f7;
  border: 1px solid #e4eeea;
  border-radius: 11px;
  transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
}

.tenant-search:focus-within {
  background: #ffffff;
  border-color: #018c74;
  box-shadow: 0 0 0 3px rgba(1, 140, 116, 0.07);
}

.tenant-search input {
  width: 100%;
  min-width: 0;
  height: 42px;
  outline: none;
  border: none;
  background: transparent;
  color: #28473e;
  font-family: inherit;
  font-size: 12px;
}

.tenant-search input::placeholder {
  color: #9aa9a3;
}

.tenant-search-clear {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 4px;
  color: #9aaba4;
  cursor: pointer;
  border: none;
  background: transparent;
}

.tenant-search-clear:hover {
  color: #018c74;
}

.filter-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  height: 20px;
  margin-top: 10px;
}

.filter-info {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #82958d;
  font-size: 10px;
}

.filter-info span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.reset-search-link {
  flex-shrink: 0;
  padding: 3px 0;
  background: transparent;
  border: none;
  color: #018c74;
  font-family: inherit;
  font-size: 10px;
  font-weight: 750;
  cursor: pointer;
}

.panel-divider {
  flex-shrink: 0;
  border-color: #edf2f0 !important;
}

.tenant-list-scroll {
  flex: 1;
  min-height: 0;
  padding: 10px 12px;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.tenant-list-scroll::-webkit-scrollbar {
  width: 5px;
}

.tenant-list-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.tenant-list-scroll::-webkit-scrollbar-thumb {
  background: #dce9e3;
  border-radius: 10px;
}

.tenant-list-scroll::-webkit-scrollbar-thumb:hover {
  background: #9dc9b9;
}

.tenant-item {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 84px;
  padding: 10px 9px;
  margin-bottom: 8px;
  border: 1px solid #edf2ef;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  content-visibility: auto;
  contain-intrinsic-size: auto 84px;
  transition: border-color 0.2s, background 0.2s, transform 0.2s, box-shadow 0.2s;
}

.tenant-item:last-child {
  margin-bottom: 0;
}

.tenant-item:hover,
.tenant-item-active {
  border-color: #c8e7dc;
  background: #f3faf7;
  box-shadow: 0 4px 13px rgba(1, 140, 116, 0.055);
}

.tenant-item:hover {
  transform: translateY(-1px);
}

.tenant-item-index {
  width: 22px;
  flex-shrink: 0;
  color: #a4b5ae;
  font-size: 9px;
  font-weight: 800;
  text-align: center;
}

.tenant-item-icon {
  width: 40px;
  height: 40px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcefe7;
  border-radius: 12px;
  background: #eef8f4;
}

.tenant-item-content {
  flex: 1;
  min-width: 0;
}

.tenant-name {
  overflow: hidden;
  color: #29483e;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow-wrap: anywhere;
}

.tenant-category {
  display: flex;
  align-items: center;
  overflow: hidden;
  margin-top: 3px;
  color: #8b9b94;
  font-size: 9px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.tenant-category .v-icon {
  flex-shrink: 0;
}

.tenant-location-status {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 5px;
  color: #91a19a;
  font-size: 9px;
}

.tenant-status-dot {
  width: 6px;
  height: 6px;
  flex-shrink: 0;
  border-radius: 50%;
}

.status-available {
  background: #20b486;
}

.status-unavailable {
  background: #d5a44b;
}

.tenant-open-btn {
  flex-shrink: 0;
  color: #9aafa6;
  transition: color 0.2s, background 0.2s;
}

.tenant-item:hover .tenant-open-btn,
.tenant-item-active .tenant-open-btn {
  color: #018c74;
  background: #e2f3ec;
}

.tenant-more {
  display: flex;
  justify-content: center;
  padding: 12px 0 6px;
}

.tenant-more button {
  padding: 8px 16px;
  border: 1px solid #d9eee6;
  border-radius: 20px;
  background: #f3faf7;
  color: #018c74;
  font-family: inherit;
  font-size: 10px;
  font-weight: 750;
  cursor: pointer;
  transition: background 0.2s;
}

.tenant-more button:hover {
  background: #e2f3ec;
}

.tenant-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  min-height: 220px;
  padding: 24px 15px;
  text-align: center;
}

.tenant-empty-icon {
  width: 65px;
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eff6f3;
  border-radius: 20px;
  margin-bottom: 14px;
}

.tenant-empty-title {
  color: #36554a;
  font-size: 13px;
  font-weight: 800;
}

.tenant-empty-description {
  max-width: 240px;
  margin: 7px 0 16px;
  color: #91a09a;
  font-size: 10px;
  line-height: 1.7;
}

.tenant-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
  min-height: 200px;
  color: #8a9b94;
  font-size: 11px;
}

.footer-indicator {
  width: 6px;
  height: 6px;
  margin-right: 8px;
  flex-shrink: 0;
  background: #cfa22d;
  border-radius: 50%;
}

.page-footer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 18px 0 6px;
  color: #98a8a1;
  font-size: 10px;
}

.footer-separator {
  margin: 0 4px;
  color: #cfa22d;
}

::v-deep .custom-cyber-marker-wrapper {
  background: transparent !important;
  border: none !important;
}

::v-deep .marker-core-fx {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 10;
  width: 14px;
  height: 14px;
  background: #cfa22d;
  border: 2px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0 0 9px rgba(207, 162, 45, 0.5);
}

::v-deep .marker-pulse-fx {
  position: absolute;
  top: 3px;
  left: 3px;
  z-index: 5;
  width: 24px;
  height: 24px;
  background: rgba(1, 140, 116, 0.2);
  border: 1.5px solid #018c74;
  border-radius: 50%;
}

::v-deep .cyber-cluster-icon {
  background: transparent !important;
  border: none !important;
}

::v-deep .cluster-outer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  background: rgba(1, 140, 116, 0.2);
  border: 2px solid #018c74;
  border-radius: 50%;
}

::v-deep .cluster-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #cfa22d, #e9b94e);
  border-radius: 50%;
  color: #ffffff;
  font-size: 11px;
  font-weight: 850;
}

::v-deep .cyber-leaflet-tooltip {
  background: #24483e !important;
  border: 1px solid rgba(255, 255, 255, 0.15) !important;
  color: #ffffff !important;
  border-radius: 7px !important;
  padding: 5px 9px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12) !important;
}

::v-deep .cyber-leaflet-tooltip::before {
  border-top-color: #24483e !important;
}

.tooltip-name {
  color: #ffffff !important;
  font-size: 10px;
  font-weight: 700;
}

::v-deep .label-kecamatan {
  background: rgba(255, 255, 255, 0.83) !important;
  border: 1px solid rgba(1, 140, 116, 0.12) !important;
  border-radius: 4px !important;
  box-shadow: none !important;
  color: #4b7265 !important;
  font-size: 9px;
  font-weight: 700;
  padding: 3px 5px !important;
}

::v-deep .label-kecamatan::before {
  display: none !important;
}

::v-deep .leaflet-control-zoom {
  overflow: hidden;
  border: 1px solid #e1ebe6 !important;
  border-radius: 10px !important;
  box-shadow: 0 3px 12px rgba(25, 65, 51, 0.08) !important;
}

::v-deep .leaflet-control-zoom a {
  color: #018c74 !important;
  border-color: #eaf0ed !important;
}

::v-deep .leaflet-control-attribution {
  font-size: 8px !important;
  background: rgba(255, 255, 255, 0.85) !important;
}

@media (max-width: 1264px) {
  .futuristic-app {
    --panel-height: 620px;
  }
}

@media (max-width: 960px) {
  .futuristic-app {
    --gap: 14px;
  }

  .content-layer {
    padding: 20px 16px 10px;
  }

  .page-intro {
    align-items: flex-start;
  }

  .intro-badge {
    padding: 11px 13px;
  }

  .workspace-grid {
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }

  .map-panel {
    height: 560px;
  }

  .tenant-panel {
    height: 560px;
  }
}

@media (max-width: 600px) {
  .futuristic-app {
    --gap: 10px;
    --radius-card: 14px;
  }

  .header-inner {
    padding: 0 8px;
  }

  .brand-mark {
    width: 35px;
    height: 35px;
  }

  .brand-name {
    font-size: 12px;
  }

  .brand-tagline {
    font-size: 8px;
  }

  .back-btn {
    width: 35px !important;
    height: 35px !important;
    margin-right: 7px;
  }

  .header-search-wrap {
    margin-right: 0 !important;
    margin-left: 8px;
  }

  .content-layer {
    padding: 16px 10px 8px;
  }

  .page-intro {
    display: block;
  }

  .intro-eyebrow {
    font-size: 9px;
    margin-bottom: 6px;
  }

  .intro-title {
    font-size: 23px;
    letter-spacing: -0.7px;
  }

  .intro-description {
    font-size: 11px;
    line-height: 1.7;
    margin-top: 6px;
  }

  .intro-badge {
    display: none;
  }

  .page-intro {
    margin-bottom: var(--gap);
  }

  .stats-grid {
    gap: 8px;
  }

  .stat-card {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 8px;
    height: 112px;
    padding: 0 12px;
  }

  .stat-icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
  }

  .stat-icon .v-icon {
    font-size: 19px !important;
  }

  .stat-label {
    font-size: 9px;
    line-height: 1.3;
    margin-bottom: 0;
  }

  .stat-value {
    font-size: 21px;
  }

  .stat-note {
    display: none;
  }

  .panel-heading {
    height: 70px;
    padding: 0 12px;
  }

  .panel-heading-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
  }

  .panel-title {
    font-size: 12px;
  }

  .panel-subtitle {
    max-width: 210px;
    font-size: 9px;
  }

  .map-live-status {
    gap: 5px;
    padding: 6px 7px;
    font-size: 8px;
  }

  .map-panel {
    height: 480px;
  }

  .tenant-panel {
    height: 520px;
  }

  .map-floating-card {
    top: 10px;
    left: 10px;
    padding: 8px 10px;
    border-radius: 10px;
  }

  .map-floating-icon {
    width: 29px;
    height: 29px;
  }

  .map-floating-label {
    font-size: 7px;
  }

  .map-floating-value {
    font-size: 11px;
  }

  .map-legend {
    left: 10px;
    bottom: 10px;
    padding: 7px 9px;
    font-size: 9px;
  }

  .panel-footer {
    height: 44px;
    padding: 0 10px;
  }

  .panel-footer-left {
    font-size: 9px;
  }

  .map-reset-btn {
    padding: 0 4px !important;
    font-size: 9px;
  }

  .tenant-panel-header {
    padding: 14px 13px 12px;
  }

  .tenant-panel-title {
    font-size: 18px;
  }

  .tenant-search {
    margin-top: 12px;
    height: 42px;
  }

  .tenant-search input {
    height: 40px;
  }

  .tenant-list-scroll {
    padding: 8px;
  }

  .tenant-item {
    gap: 8px;
    min-height: 76px;
    padding: 9px 7px;
    border-radius: 10px;
    contain-intrinsic-size: auto 76px;
  }

  .tenant-item-index {
    width: 17px;
    font-size: 8px;
  }

  .tenant-item-icon {
    width: 35px;
    height: 35px;
    border-radius: 10px;
  }

  .tenant-name {
    font-size: 10px;
  }

  .tenant-category,
  .tenant-location-status {
    font-size: 8px;
  }

  .tenant-open-btn {
    width: 25px !important;
    height: 25px !important;
  }

  .page-footer {
    padding-top: 14px;
    font-size: 9px;
  }
}

@media (max-width: 380px) {
  .brand-copy {
    display: none !important;
  }

  .header-search-wrap {
    margin-left: 5px;
  }

  .intro-title {
    font-size: 21px;
  }

  .stat-card {
    height: 104px;
    padding: 0 9px;
  }

  .stat-value {
    font-size: 19px;
  }

  .map-panel {
    height: 420px;
  }

  .tenant-panel {
    height: 480px;
  }

  .map-live-status {
    font-size: 7px;
  }
}
</style>
